import { Component, Inject, Input } from '@angular/core';
import { Package } from '../../../../packages/package.models';

@Component({
  selector: 'xp-select-picker-package',
  template: `
    <div class="select-picker-package">
      <div class="select-picker-item">
        <div class="select-picker-header">
          <div class="select-picker-icon">
            <svg *ngIf="package.flow_type === 'dataflow'" class="icon icons-master-expanded_icon-navmain-packages">
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                href="#img-sprite_icons-master-expanded_icon-navmain-packages"
              ></use>
            </svg>
            <svg
              *ngIf="package.flow_type === 'workflow'"
              class="icon icons-master-expanded_icon-navmain-packages icon-workflow"
            >
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                href="#img-sprite_icon-icons-master-expanded_icon-navmain-workflow"
              ></use>
            </svg>
          </div>
          <div class="select-picker-name">
            <div class="select-picker-name-title">
              <span [innerHTML]="package.name | xpLengthCheck: 50 | xpHighLight: highlightValue"></span>
              <button type="button" class="btn btn-sm btn-default" (click)="openPackage($event, package)">
                Open <i class="fa fa-external-link"></i>
              </button>
            </div>
            <span
              class="select-picker-name-description"
              [innerHTML]="package.description | xpLengthCheck: 120 | xpHighLight: highlightValue"
            ></span>
          </div>
        </div>
        <div class="select-picker-body">
          <span class="small" *ngIf="package.workspace"
            >Workspace: {{ package.workspace.name | xpLengthCheck: 40 }}</span
          >
          <span class="small"
            >last modified:
            <span class="date-tooltip" [matTooltip]="package.updated_at | xpDateUTC" matTooltipPosition="above">{{
              package.updated_at | xpPrettyDate
            }}</span></span
          >
        </div>
      </div>
    </div>
  `,
})
export class XpSelectPickerPackageComponent {
  @Input() package: Package;
  @Input() highlightValue: string = '';

  constructor(@Inject('$stateParams') private $stateParams: any) {}

  openPackage(event: MouseEvent, packageItem: Package) {
    window.open(`/${this.$stateParams.account_id}/packages/${packageItem.id}/edit`);
    event.stopPropagation();
  }
}
